import { useQuery } from "@tanstack/react-query"
import { fetchCategoriesForNavbar } from "@/api/categoryService"

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories", "navbar"],
    queryFn: ({ signal }) => fetchCategoriesForNavbar(signal),
  })
}

